import { connect } from 'react-redux';
import { RootState } from 'redux/store';
import { isCustomerLoggedIn } from 'redux/customer/customer.selectors';
import Gate from 'components/Gate';

const mapStateToProps = (state: RootState): { isActive: boolean } => ({
  isActive: isCustomerLoggedIn(state),
});

export default connect(mapStateToProps)(Gate);
